import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import { connectTransfers as endpoints } from '../api_urls'
import { client } from '../utils'
import { toast } from '@CommonComponents/toast'

const ExportModal = props => {
  const [exportModalOpen, toggleExportModalOpen] = useState(false)
  const [exportWorking, toggleExportWorking] = useState(false)

  const handleExportClick = () => {
    toggleExportWorking(true)
    client
      .post(endpoints.exportRecentTransfers(), {
        account_id: props.accountID,
      })
      .then(() => {
        toast.success("Export Started - We have started exporting your payments and the file will be available shortly. Refresh this page to see changes.")
        toggleExportWorking(false)
        toggleExportModalOpen(false)
      })
      .catch(err => {
        toast.error(`There was an error trying to export the payments. Please contact us if the error continues. ${err}`)
        toggleExportWorking(false)
      })
  }

  return (
    <React.Fragment>
      <div className="pull-right">
        <button
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
          onClick={() => toggleExportModalOpen(true)}
        >
          Export <div className="fa-regular fa-external-link-square ml-2" />
        </button>
      </div>
      <Modal show={exportModalOpen}>
        <Modal.Header>
          <Modal.Title>Export Payments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The past six weeks of data will be exported.</p>
          <p>
            If you would like a report with a different time period, please
            contact us.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-myed btn-default btn-default-myed"
            onClick={() => toggleExportModalOpen(false)}
          >
            <div className="fa-regular fa-times mr-2" /> Cancel
          </Button>
          <Button
            disabled={exportWorking}
            className="btn btn-success btn-myed btn-success-myed"
            onClick={() => handleExportClick()}
          >
            <div
              className={
                exportWorking
                  ? 'far fa-spinner fa-spin mr-2'
                  : 'far fa-check mr-2'
              }
            />{' '}
            Start Export
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}

ExportModal.propTypes = {
  accountID: PropTypes.string,
}

export default ExportModal
